import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';

import { theme } from './theme';
import { Amount } from './amount';
import { Period } from '@matematykagryzie/consts';

interface PriceProps {
  regularAmount: number;
  amount: number;
  period: Period;
  expiresAt: number;
}

function getExpiryText(period: Period, expiresAt: number): string | null {
  if (!period && !expiresAt) {
    return null;
  }
  if (period === Period.M1) {
    return 'Dostęp na miesiąc';
  }
  if (period === Period.M3) {
    return 'Dostęp na 3 miesiące';
  }
  if (period === Period.M6) {
    return 'Dostęp na 6 miesięcy';
  }
  if (period === Period.M12) {
    return 'Dostęp na 12 miesięcy';
  }
  return (
    'Dostęp do ' +
    new Date(expiresAt).toJSON().split('T')[0].split('-').reverse().join('.')
  );
}

export const Price: FunctionComponent<PriceProps> = ({
  period,
  expiresAt,
  amount,
  regularAmount,
}) => {
  const expiryText = getExpiryText(period, expiresAt);

  return (
    <Box
      mt={1}
      mb={1}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Box
        p={1}
        style={{
          background: theme.palette.primary.light,
          color: theme.palette.primary.dark,
          borderRadius: theme.shape.borderRadius,
          fontWeight: 500,
          fontSize: 13,
          lineHeight: 22 / 13,
          letterSpacing: 0.25,
          textAlign: 'center',
        }}
      >
        Płacisz tylko raz
        <br />
        {!!expiryText && expiryText}
      </Box>
      <Amount amount={amount} regularAmount={regularAmount} />
    </Box>
  );
};

export default Price;
